import React from "react";
import DataList from "components/list/DataList";
import DBDisplayComp2 from "components/resource/DBDisplayComp2";
import GraphqlFragment from "lib/GraphqlFragment";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import navigate from "lib/navigate";
import DBResourceQueryGroupComp2 from "components/resource/DBResourceQueryGroupComp2";
import DBResourceDetailLightBox2 from "components/resource/DBResourceDetailLightBox2";
import cateAPI from "lib/cateAPI";
import { inject, observer } from "mobx-react";
import ReactHtmlParser from "react-html-parser";

const getDBResourceList = gql`
  query getDBResourceList($searchForm: SearchForm) {
    getDBResourceList(Input: $searchForm) {
      display {
        field
        name
        position
        type
        isUnEscape
      }
      sort {
        name
        order
        field
        default
      }
      batch {
        ...getElemtn
      }
      list {
        values {
          ref {
            key
            value
          }
          resourceItem {
            recommendResource
            newResource
            trialResource
            isMaintain
            isMaintainShow
            joCount
            pJoCount
            ebookCount
            dbAttachList {
              showName
              attachPath
            }
            dbURLList {
              showName
              url
              openWin
            }
          }
        }
      }
      options {
        max
        pagesize
        showpage
      }
      info {
        total
        count
        limit
        pageNo
        totalPage
        start
        hyftdToken
        userCollectionList
        sortFieldList {
          type
          order
          message
        }
        journalCollect
        ermEJournal
        ermProcLink
        pages {
          val
          active
        }
        showNext
        showPrevious
        additionalData
      }
    }
  }
  ${GraphqlFragment.defaultLayoutFragment}
`;

@inject("appStore")
@observer
class DBResourceListComp2 extends React.Component {
  constructor(props) {
    super(props);
    let { globalConfig } = props.appStore;
    let noDataType = 1;
    let noDataTypeString = globalConfig["jumperrwd.resource.noDataType"] || "";
    if (noDataTypeString !== "") {
      noDataType = parseInt(noDataTypeString);
    }
    this.state = {
      auth: props.readerStore.auth,
      dbID: "",
      resourceType: "databases",
      isAllTag: false,
      ids: [],
      sortFieldList: [],
      showSort: false,
      showFilter: false,
      refetch: null,
      noDataType,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (
      JSON.stringify(props.searchForm) !== JSON.stringify(this.props.searchForm)
    ) {
      this.setState({ ids: [] });
    }
    if (this.state.auth !== props.readerStore.auth) {
      this.setState({ auth: props.readerStore.auth });
    }
  }

  @autobind
  handleShowSort(e) {
    e.preventDefault();
    this.setState({ showSort: !this.state.showSort });
  }

  @autobind
  changeShowType(showType, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.showType = showType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  onQueryCompleted(data) {
    let { info } = data.getDBResourceList;
    let { limit, start, count, sortFieldList, total, userCollectionList } = info;
    
    // 初始化 appStore 的收藏列表
    if (userCollectionList !== null && userCollectionList !== undefined) {
      this.props.appStore.initCollections(userCollectionList, "databases");
    }
    let { search } = this.props;
    let params = { ...search };
    let { resourceConfig } = this.props.appStore;
    let size = limit;
    if (count - start < size) {
      size = count - start;
    }
    /*let tagSize = 0;
    let ids = [];

    values.map((value) => {
      let { ref } = value;
      ref.map((v) => {
        if (v.key === "id") {
          ids.push(v.value);
          if (userCollectionList !== null && userCollectionList !== undefined) {
            if (userCollectionList.includes(v.value)) {
              tagSize++;
            }
          }
        }
      });
    });

    let isAllTag = this.state.isAllTag;
    if (size === tagSize) {
      isAllTag = true;
    } else {
      isAllTag = false;
    }
    let idsEqual =
      ids.length === this.state.ids.length &&
      ids.every((id, k) => id === this.state.ids[k]);
    if (isAllTag !== this.state.isAllTag || !idsEqual) {
      this.setState({ isAllTag: isAllTag, ids: ids });
    }*/

    if (
      sortFieldList !== null &&
      sortFieldList !== undefined &&
      JSON.stringify(sortFieldList) !== JSON.stringify(this.state.sortFieldList)
    ) {
      this.setState({ sortFieldList: sortFieldList });
    }

    if (total !== this.props.appStore.dbResourceCount) {
      this.props.appStore.setDBResourceCount(total);
    }

    if (total === 0 && params.searchTarget !== params.resourceType) {
      if (resourceConfig && resourceConfig.resourceTabList) {
        let breakPoint = false;
        resourceConfig.resourceTabList.map((resourceTab) => {
          if (breakPoint) {
            return "";
          }
          if (
            resourceTab === "journal" &&
            this.props.appStore.journalResourceCount > 0
          ) {
            this.setResourceType("journal");
            breakPoint = true;
          } else if (
            resourceTab === "paper_journal" &&
            this.props.appStore.pJournalResourceCount > 0
          ) {
            this.setResourceType("paper_journal");
            breakPoint = true;
          } else if (
            resourceTab === "ebook" &&
            this.props.appStore.ebookResourceCount > 0
          ) {
            this.setResourceType("ebook");
            breakPoint = true;
          }
          return "";
        });
      }
    }
  }

  @autobind
  setResourceType(resourceType) {
    let { search, location } = this.props;
    let params = { ...search };
    params.resourceType = resourceType;
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  handleTagAll(e) {
    e.preventDefault();
    if (this.state.auth) {
      if (!this.state.isAllTag) {
        cateAPI
          .addListCate(this.state.ids, this.props.resourceType)
          .then((data) => {
            if (
              this.state.refetch !== null &&
              this.state.refetch !== undefined
            ) {
              this.state.refetch();
            }
          });
      } else {
        cateAPI
          .delListCate(this.state.ids, this.props.resourceType)
          .then((data) => {
            if (this.state.refetch && this.state.refetch !== undefined) {
              this.state.refetch();
            }
          });
      }
    } else {
      this.props.appStore.openLogin();
    }
  }

  @autobind
  getRefetch(refetch) {
    this.setState({ refetch: refetch });
  }

  @autobind
  changeSort(sort) {
    let { search, location } = this.props;
    let params = { ...search };
    let sortType = "";
    let order = "";
    let sortItem = sort.split("-");
    if (sortItem.length === 2) {
      sortType = sortItem[0];
      order = sortItem[1];
    }
    params.sort = sortType;
    params.order = order;
    navigate([location.pathname, qs.stringify(params)].join("?"));
    this.setState({ showSort: false });
  }

  @autobind
  changeShowFilter(type) {
    if (type) {
      this.setState({ showFilter: true });
    } else {
      this.setState({ showFilter: false });
    }
  }

  @autobind
  handleClick(item) {
    this.setState({ dbID: item.id });
    this.detailLightBox.popup();
    window.history.pushState(
      "",
      "",
      "/resourceDetail?resourceType=databases&id=" + item.id
    );
  }

  @autobind
  changePageType(pageType, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = {};
    params.resourceType = search.resourceType;
    params.pageType = pageType;
    if (search.searchBlockType) {
      params.searchBlockType = search.searchBlockType;
    }
    if (search.searchTarget) {
      params.searchTarget = search.searchTarget;
    }
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  @autobind
  changePageTypeWithClassSN(sn, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    params.resourceType = search.resourceType;
    params.pageType = "class";
    params.par = sn;
    params.sc = "1";
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  render() {
    let { searchForm, appStore, t, pageType } = this.props;
    let { sortFieldList, dbID, resourceType, showFilter } = this.state;
    let { dbResourceCount } = appStore;
    /*let toTagAll = true;
    if (isAllTag && dbResourceCount > 0) {
      toTagAll = false;
    }*/
    let showList = false;
    if (pageType === "list" || pageType === "search" || pageType === "hot") {
      showList = true;
    } else if (pageType === "subject" && searchForm.subject !== undefined) {
      showList = true;
    } else if (
      pageType === "unit" &&
      (searchForm.college !== undefined || searchForm.unit !== undefined)
    ) {
      showList = true;
    } else if (
      pageType === "class" &&
      searchForm.par !== undefined &&
      searchForm.sc !== "1"
    ) {
      showList = true;
    }
    return (
      <>
        <div className="row-col2">
          {showList && (
            <DBResourceQueryGroupComp2
              {...this.props}
              changeShowFilter={this.changeShowFilter}
              showList={showList}
              showFilter={showFilter}
            />
          )}
          <div className="col-right">
            <a
              className="accesskey"
              href="javascript:;"
              id="aC"
              accessKey="C"
              title={this.props.t("jumperrwd.common.mainContenctArea")}>
              :::
            </a>
            <div className="searchList">
              <div className="searchList-inform">
                <h2 className="secHead1">
                  {t("jumperrwd.resource.dbListTitle")}
                </h2>
                <button
                  type="button"
                  tabIndex="0"
                  className="showRefine"
                  aria-label={this.props.t("jumperrwd.common.filterButton")}
                  onClick={(e) => {
                    e.preventDefault();
                    this.changeShowFilter(true);
                  }}>
                  {t("jumperrwd.common.adjustQuery")}
                </button>
              </div>
              {pageType !== "search" && (
                <section className="category">
                  <button
                    type="button"
                    className={pageType === "list" ? "now" : ""}
                    role="tab"
                    aria-selected={pageType === "list" ? "true" : "false"}
                    onClick={this.changePageType.bind(this, "list")}>
                    {t("jumper.common.tabbar.browseall")}
                  </button>
                  <button
                    type="button"
                    className={pageType === "hot" ? "now" : ""}
                    role="tab"
                    aria-selected={pageType === "hot" ? "true" : "false"}
                    onClick={this.changePageType.bind(this, "hot")}>
                    {t("jumper.common.tabbar.bypopular")}
                  </button>
                </section>
              )}
              <section className="searchList-summmary">
                <p role="status" aria-atomic="true" id="resultSummary">
                  {t("jumperrwd.common.searchResult")}：
                  {ReactHtmlParser(
                    t("jumperrwd.list.totalAmount", {
                      total: dbResourceCount,
                    })
                  )}
                </p>
                <div className="sorting" aria-label={t("jumperrwd.common.sortType")}>
                  <select
                    name="dbTableSort"
                    title={t("jumperrwd.list.selectSortType")}
                    value={
                      this.props.searchForm.sort +
                      "-" +
                      this.props.searchForm.order
                    }
                    onChange={(e) => this.changeSort(e.target.value)}>
                    {sortFieldList.map((sortField) => {
                      return (
                        <option
                          value={[sortField.type, sortField.order].join("-")}>
                          {t(sortField.message)}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </section>
              {showList && (
                <ol className="list">
                  <DataList
                    query={getDBResourceList}
                    variables={{
                      searchForm: this.props.searchForm,
                    }}
                    fetchPolicy={"network-only"}
                    displayComp={DBDisplayComp2}
                    pagination={"FixedPagination"}
                    getRefetch={this.getRefetch}
                    handleClick={this.handleClick}
                    onQueryCompleted={this.onQueryCompleted}
                    showNoData={true}
                    noDataType={this.state.noDataType}
                  />
                </ol>
              )}
            </div>
          </div>
        </div>
        <DBResourceDetailLightBox2
          ref={(c) => {
            this.detailLightBox = c;
          }}
          id={dbID}
          resourceType={resourceType}
          {...this.props}
        />
      </>
    );
  }
}

export default DBResourceListComp2;
